import { useAuthStore } from '@/stores/auth'
import { useFormStore } from '@/stores/form'
import { defineStore } from 'pinia'

export const usePreloadStore = defineStore('preloadStore', () => {
  const authStore = useAuthStore()

  const prepareForm = async () => {
    const formStore = useFormStore()

    const { identityNumber, arabicFullName, englishFullName, passportNumber, passportExpiryDate } =
      authStore.individualInfo

    Object.assign(formStore.draft.request, {
      arabicName: arabicFullName,
      englishName: englishFullName,
      identityNumber,
      passportNumber,
      passportExpiryDate
    })
  }

  const actions = { prepareForm }

  return { ...actions }
})

export default async function () {
  await usePreloadStore().prepareForm()
}
